import { Component, computed } from '@angular/core';
import { CustomWidget } from '../widget';
import { CommonModule } from '@angular/common';
import { NumberPipe } from '@pipes/number.pipe';
import { TPipe, TRANSLATION_PREFIX } from '@pipes/t.pipe';

@Component({
  selector: 'abb-min-max-widget',
  standalone: true,
  imports: [CommonModule, NumberPipe, TPipe],
  template: `
    <div
      class="flex justify-between gap-x-5 text-sm text-abb-font/70 font-medium"
    >
      <div class="flex-1 text-center bg-abb-black/[0.02] py-3 rounded-sm">
        {{ propertyOrGroup() }}
      </div>
      @if (device()) {
      <div class="flex-1 text-center bg-abb-black/[0.02] py-3 rounded-sm">
        {{ device() }}
      </div>
      }
    </div>
    <div class="mt-4 flex justify-between gap-x-8 text-3xl font-bold">
      <div class="flex-1 text-center py-3 rounded-sm">
        <div class="text-sm text-abb-font/70">{{ 'Min' | t }}</div>
        {{ min() | number }}
      </div>
      <div class="flex-1 text-center py-3 rounded-sm">
        <div class="text-sm text-abb-font/70">{{ 'Max' | t }}</div>
        {{ max() | number }}
      </div>
      <div class="flex-1 text-center py-3 rounded-sm">
        <div class="text-sm text-abb-font/70">{{ 'Avg' | t }}</div>
        {{ avg() | number }}
      </div>
    </div>
  `,
  styles: ``,
  providers: [
    { provide: TRANSLATION_PREFIX, useValue: 'dashboards.max_min_values' },
  ],
})
export class MinMaxWidgetComponent extends CustomWidget {
  min = computed(() => {
    const data = this.data();
    if (data && data.__typename === 'MaxMinData') {
      return data.min;
    }
    return 0;
  });
  max = computed(() => {
    const data = this.data();
    if (data && data.__typename === 'MaxMinData') {
      return data.max;
    }
    return 0;
  });
  avg = computed(() => {
    const data = this.data();
    if (data && data.__typename === 'MaxMinData') {
      return data.avg;
    }
    return 0;
  });
  propertyOrGroup = computed(() => {
    const data = this.data();
    if (data && data.__typename === 'MaxMinData') {
      return data.propertyOrGroup;
    }
    return '';
  });
  device = computed(() => {
    const data = this.data();
    if (data && data.__typename === 'MaxMinData') {
      return data.device ?? '';
    }
    return '';
  });
}
